<template>
  <div>
    <!-- new  -->
    <div class="px-4 sm:px-10 bg-white w-full sm:w-[450px] max-w-full mx-auto">
      <div class="py-4">
        <div class="w-full text-xl font-bold mb-2 text-center text-black">
          CREATE PASSWORD
        </div>
        <div class="text-left my-2 text-xs">
          Your password must have:
          <ul class="list-disc pl-5">
            <li>Minimum of twelve (12) characters</li>
            <li>At least one capital letter (A-Z)</li>
            <li>At least one lowercase letter (a-z)</li>
            <li>At least one number (0-9)</li>
            <li>At least one special character (e.g. ! ? * @ # $ & ^)</li>
          </ul>
        </div>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <div class="pt-4 pb-1">
          <form @submit.prevent="newPwSubmitted">
            <div class="space-y-4">
              <div>
                <v-text-field
                  clearable
                  v-model="passwordValue"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  hint="At least 12 characters"
                  placeholder="Encode your new password here"
                  name="input-10-1"
                  counter
                  outlined
                  @click:append="show1 = !show1"
                  class="mb-4"
                ></v-text-field>
                <v-text-field
                  clearable
                  v-model="rePasswordValue"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show2 ? 'text' : 'password'"
                  hint="At least 12 characters"
                  placeholder="Re-type your new password here"
                  name="input-10-1"
                  counter
                  outlined
                  @click:append="show2 = !show2"
                ></v-text-field>
              </div>
            </div>

            <password-meter
              v-if="passwordValue"
              :password="passwordValue"
              @score="onScore"
              class="mt-4"
            />
            <div class="flex justify-center mt-6">
              <v-btn
                :progress="progress"
                class="w-full sm:w-1/2 rounded-md bg-[#ED7D31] py-2 text-white"
                @click="newPwSubmitted"
              >
                Save New Password
              </v-btn>
            </div>
          </form>
        </div>
      </div>
      <div class="text-black text-center mt-4" v-if="strength && passwordValue">
        {{ capitalize(strength) }}
      </div>
      <div class="text-black text-center mt-2" v-if="score === 0">
        Use a better password
      </div>
    </div>
    <v-snackbar bottom v-model="snackbar" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import PasswordMeter from "vue-simple-password-meter";
export default {
  components: { PasswordMeter },
  data() {
    return {
      progress: false,
      snackbar: false,
      snackbarText: "",
      show1: false,
      show2: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 12) || "Min 12 characters",
      },
      loading: false,
      hidePw: true,
      passwordValue: null,
      rePasswordValue: null,
      score: null,
      strength: "",
    };
  },
  methods: {
    onSnackBar(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    onClickHidePw() {
      this.hidePw = !this.hidePw;
    },
    capitalize(text) {
      return text.toUpperCase();
    },
    onScore({ score, strength }) {
      this.strength = strength;
      this.score = score;
    },
    validatePassword(password) {
      const minLength = password.length >= 12;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /[0-9]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

      return (
        minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
      );
    },
    newPwSubmitted() {
      try {
        this.hidePw = true;
        this.progress = true;

        if (!this.passwordValue || !this.rePasswordValue) {
          throw new Error("Please enter both password fields.");
        }

        if (!this.validatePassword(this.passwordValue)) {
          throw new Error("Password does not meet the security requirements.");
        }

        if (this.passwordValue !== this.rePasswordValue) {
          throw new Error("Passwords do not match.");
        }

        this.loading = true;
        this.$emit("newPwSubmitted", this.passwordValue);
      } catch (error) {
        this.onSnackBar(error.message);
      } finally {
        this.progress = false;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.po-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 10px;
  margin-top: 8px;
}

.po-password-strength-bar.risky {
  background-color: #f95e68;
}

.po-password-strength-bar.guessable {
  background-color: #fb964d;
}

.po-password-strength-bar.weak {
  background-color: #fdd244;
}

.po-password-strength-bar.safe {
  background-color: #b0dc53;
}

.po-password-strength-bar.secure {
  background-color: #35cc62;
}
</style>
